import { AlarmNotificationTypeEnum } from "../../common/enums/AlarmNotificationTypeEnum";


export const ALWAYS_SCHEDULE: number = 1;

export interface IEditDTO {
    id: number;
    name: string;
    tiers: Array<IEditTierDTO>;
}

export interface IEditScheduleDTO {
    scheduleID: number;
    notificationListID: number;
}

export interface IEditTierDTO {
    id: number;
    name: string;
    type?: AlarmNotificationTypeEnum;
    delayMinutes?: number;
    repeatMinutes?: number;
    repeatCount?: number;


    repeatZCount?: number;
    repeatCountMinutes?: number;


    description?: string;
    schedules: Array<IEditScheduleDTO>;
}

// Reference Data DTOs
export interface IReferenceDTO {
    maxAlarmRepeatLimit: number;
    organizations: Array<IReferenceOrganizationDTO>;
    schedules: Array<IReferenceScheduleDTO>;
}

export interface IReferenceNotificationListDTO {
    id: number;
    name: string;
    selected?: boolean;
}

export interface IReferenceOrganizationDTO {
    id: number;
    name: string;
    notificationLists: Array<IReferenceNotificationListDTO>;
}

export interface IReferenceScheduleDTO {
    id: number;
    name: string;
}

// Summary Format DTOs
export interface ISummaryDTO {
    id: number;
    name: string;
    setPoints: Array<ISummarySetPointDTO>;
    tiers: Array<ISummaryTierDTO>;
}

export interface ISummaryNotificationListDTO {
    id: number;
    name: string;
    organizationID: number;
}

export interface ISummaryScheduleDTO {
    id: number;
    name: string;
    notificationLists: Array<ISummaryNotificationListDTO>;
}

export interface ISummarySetPointDTO {
    id: number;
    name: string;
}

export interface ISummaryTierDTO {
    id: number;
    name: string;
    description: string;
    schedules: Array<ISummaryScheduleDTO>;
}



const defaultEditAlarmScheme: IEditDTO = {
    id: 0,
    name: '',
    tiers: []
};

export {defaultEditAlarmScheme}
